import { render } from "./Payroll.vue?vue&type=template&id=d195b1da&scoped=true"
import script from "./Payroll.vue?vue&type=script&lang=js"
export * from "./Payroll.vue?vue&type=script&lang=js"

import "./Payroll.vue?vue&type=style&index=0&id=d195b1da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d195b1da"]])

export default __exports__